import * as GUI from "babylonjs-gui";

export class PopUp{  
    constructor(canvas, advancedTexture, product, imageSourceLink, textDescription){
        this.canvas = canvas;
        this.advancedTexture = advancedTexture;
        this.productRef = product;
        if(this.canvas.width > this.canvas.height){
            this.width = this.canvas.width*0.6;
            this.height = this.canvas.height/1.5;
        }else{
            this.width = this.canvas.width*0.8;
            this.height = this.canvas.height/2;
        }

        this.panelBlackout = this.createPanelBlackout();
        this.panelPopUpBoundary = this.createPanelPopUpBoundary();
        this.imagePopUp = this.createImagePopUp(imageSourceLink);
        this.textDescriptionText = this.createTextDescriptionText(textDescription);
        this.panelTouch = this.createPanelTouch();
        this.setPopUpVisibility(false);
    }

    createPanelBlackout(){
        var blackout = new GUI.Rectangle();
        blackout.widthInPixels = this.canvas.width+300;
        blackout.heightInPixels = this.canvas.height+300;
        blackout.background = "black";
        blackout.alpha = 0.2;
        blackout.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        blackout.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        this.advancedTexture.addControl(blackout); 
        blackout.zIndex = 4;

        return blackout;
    }  

    createPanelTouch(){
        var panelTouch = new GUI.Rectangle();
        panelTouch.widthInPixels = this.canvas.width+300;
        panelTouch.heightInPixels = this.canvas.height+300;
        panelTouch.background = "black";
        panelTouch.alpha = 0;
        panelTouch.isPointerBlocker = true;
        panelTouch.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        panelTouch.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        this.advancedTexture.addControl(panelTouch); 
        panelTouch.zIndex = 10;

        return panelTouch;
    }   
        
    createPanelPopUpBoundary(){
        var width, height;
        var panelPopUpBoundary = new GUI.Rectangle();
        if(this.canvas.width > this.canvas.height){
            width = this.canvas.width*0.6;
            height = this.canvas.height/1.5;
        }else{
            width = this.canvas.width*0.8;
            height = this.canvas.height/2;
        }
        panelPopUpBoundary.widthInPixels = width;
        panelPopUpBoundary.heightInPixels = height;
        panelPopUpBoundary.color = "transparent";
        panelPopUpBoundary.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        panelPopUpBoundary.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        panelPopUpBoundary.isVisible = true;
        this.advancedTexture.addControl(panelPopUpBoundary);  
        panelPopUpBoundary.zIndex = 5;
        return panelPopUpBoundary;
    }

    createTextDescriptionText(textDescription){
        var textDescriptionText = new GUI.TextBlock();
        textDescriptionText.text = textDescription;
        textDescriptionText.color = "white";
        textDescriptionText.outlineColor = "black";
        textDescriptionText.outlineWidth = 1;
        if(this.canvas.width > this.canvas.height){
            textDescriptionText.fontSize = this.height/15;
        }else{
            textDescriptionText.fontSize = this.width/15;
        }
        textDescriptionText.resizeToFit = true;
        textDescriptionText.textWrapping = GUI.TextWrapping.WordWrap;
        textDescriptionText.fontweight = "bold";
        textDescriptionText.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        textDescriptionText.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.panelPopUpBoundary.addControl(textDescriptionText); 
        
        return textDescriptionText;
    }

    createImagePopUp(imageSourceLink){ 
        var iconImage = new GUI.Image(name + "_icon", imageSourceLink);
        iconImage.widthInPixels = this.width*0.8;
        iconImage.heightInPixels = this.height*0.8;
        iconImage.stretch = GUI.Image.STRETCH_UNIFORM;
        iconImage.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        iconImage.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        iconImage.color = "transparent";
        this.panelPopUpBoundary.addControl(iconImage);
        iconImage.alpha = 2; 

        return iconImage;
    }

    updatePopUp(imageLink,text) {
        if(imageLink != "null")
            this.imagePopUp.source = "https://charliebehan.github.io/DromoneARDemo/textures/"+imageLink;
        else
            this.imagePopUp.source = null;  
        
        this.textDescriptionText.text = text;
    }

    setPopUpVisibility(bool) {
        this.panelBlackout.isVisible = bool;
        this.panelPopUpBoundary.isVisible = bool;
        this.imagePopUp.isVisible = bool;
        this.textDescriptionText.isVisible = bool;
        this.panelTouch.isVisible = bool;
        this.panelTouch.isEnabled = bool;
    }


}